export default {
  emojiPicker: {
    search: "Rechercher un émoji",
    more: "Plus d'émojis",
    loadError: "Impossible de charger les émojis.",
    retry: "Réessayer",
    group: {
      recent: "Utilisés fréquemment",
      smileys: "Smileys et personnes",
      nature: "Animaux et nature",
      food: "Nourriture et boissons",
      travel: "Voyages et lieux",
      activities: "Activités",
      objects: "Objets",
      symbols: "Symboles",
      flags: "Drapeaux"
    }
  }
};
